import React, { useState, useEffect,  useContext } from 'react';
import './AlarmHistory.css';
import DropDown from '../DropDown/DropDown';
import { CardAlarmHistoryContext } from '../../contexts/CardAlarmHistoryContext';
import logComponent from '../../common/logComponent';


export default function AlarmHistoryTimeRange({ updateTimeRange }) {
  const cardAlarmHistoryContext = useContext(CardAlarmHistoryContext);
  const [currentTimeRange, setCurrentTimeRange] = useState(null);
  const { timeRanges } = cardAlarmHistoryContext;

  useEffect(() => {
    if (logComponent('AlarmHistoryTimeRange')) {console.debug('AlarmHistoryTimeRange useEffect [cardAlarmHistoryContext.alarmHistoryTimeRange ]'); }
    setCurrentTimeRange(cardAlarmHistoryContext.alarmHistoryTimeRange);

  }, [cardAlarmHistoryContext.alarmHistoryTimeRange]);


  if (logComponent('AlarmHistoryTimeRange')) { console.debug('AlarmHistoryTimeRange rendered'); }


  return (
    <DropDown className="Alarm-History__drop-down" items={timeRanges} selectedItem={currentTimeRange} onSelect={updateTimeRange} />
  );
}